import React, { useEffect, useState } from "react";
import { s360ConfigService } from "../../../Services/S360Config";
import { convertEpochToTimestamp} from "../../../../utils/dateConversion";
import apiService from "../../../Services/APIService";
import flowMemorySingleton from "../../../Services/FlowMemorySingleton";

function NCXTranscriptFileView(props) {
    const { fileName, fileUrl, id, creator, senderId, receivedTimestamp, senderName, messageId} = props;
      const [agentImage, setAgentImage] = useState(false);

    const senderNameStyle = {
        fontWeight: "bold",
        marginBottom: "0.25rem",
        fontSize: "x-small",
    };

    const generateAgentAvatar = () => {
        if (s360ConfigService.config?.sandBox) {
        return (
            <svg
            width="30"
            height="30"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            style={{
                marginRight: "8px",
            }}
            >
            <circle
                cx="50"
                cy="50"
                r="48"
                stroke="#D1D5DB"
                strokeWidth="4"
                fill="#F9FAFB"
            />
            <circle cx="50" cy="35" r="15" fill="#9CA3AF" />
            <path
                d="M20 80c0-16.57 13.43-30 30-30s30 13.43 30 30"
                fill="#9CA3AF"
            />
            </svg>
        );
        }
        if (agentImage) {
        return (
            <img
            src={agentImage}
            alt=""
            style={{
                width: "30px",
                height: "30px",
                borderRadius: "20px",
                marginRight: "8px",
                objectFit: "cover",
            }}
            />
        )
        }
    };

    const fetchNewAgentImage = async (senderId) => {
        let imgData = await apiService.getAgentImage(senderId);
        setAgentImage(imgData?.data?.signedURL);
        flowMemorySingleton.setCurrentAgentImageUrl(imgData?.data?.signedURL);
    }

    useEffect(() => {
        if (creator === "AGENT") {
        if (senderId !== flowMemorySingleton.getCurrentAgentUserId()) {
            flowMemorySingleton.setCurrentAgentUserId(senderId);
            fetchNewAgentImage(senderId); 
        } else {
            setAgentImage(flowMemorySingleton.getCurrentAgentImageUrl())
        }
        }
    }, [])
    
    return (
        <div style={{ width: '95vw', display: 'flex', flexDirection: 'column', alignItems: ["USER", "CUSTOMER"].includes(creator) ? 'flex-end' : 'flex-start' }}>
            {senderName &&
                creator === "AGENT" && (
                <div
                    style={{...senderNameStyle, paddingLeft: '40px'}}
                    className="sender-name-agent"
                    key={`${messageId}-sendername`}
                >
                    {senderName && senderName()} - {convertEpochToTimestamp(receivedTimestamp)}
                </div>
            )}
            <div key={`${id}-transcript-file`} style={{ width: '95vw', padding: '16px', display: 'flex', flexDirection: 'row', justifyContent: ["USER", "CUSTOMER"].includes(creator) ? 'flex-end' : 'flex-start' }}>
                {(creator && creator === "AGENT" && senderId && s360ConfigService?.config?.configDetails?.showAgentInfo && agentImage) && generateAgentAvatar()}
                <div style={{ border: '1px solid #d9d9d9', borderRadius: '9px', padding: '16px' }}>
                    <a href={fileUrl} style={{ color: s360ConfigService?.config?.configDetails?.primaryColor || "#015fe" }}>{fileName}</a>
                </div>
            </div>
        </div>
    )
}

export default NCXTranscriptFileView;